<template>
  <div v-if="product && productPrice">
    <define-badge-template>
      <product-badge v-if="product.badge" v-bind="product.badge" :class="brandClasses.headingProductBadge" />
    </define-badge-template>
    <define-title-template>
      <h1 :class="brandClasses.headingProductName" data-test-id="product-name">
        {{ product.name }}
      </h1>
    </define-title-template>
    <div class="space-y-2">
      <template v-if="$feature.showBadgeAboveTitle">
        <badge-template />
        <title-template />
        <product-eyebrow />
      </template>
      <template v-else>
        <product-eyebrow />
        <title-template />
        <badge-template />
      </template>
    </div>
    <product-pricing
      :class="brandClasses.headingPrice"
      :currency="product.currency"
      :price="productPrice"
      :show-discount-percentage="$feature.showDiscountPercentageOnCatalog"
      :show-original-price-for-omnibus="$feature.showOmnibusBadgeOnQuickshopAndPDP"
      show-sale-price-tooltip
    />
    <p v-if="product.promoExclusionsMessage" class="mt-2 text-xs">
      {{ product.promoExclusionsMessage }}
    </p>
  </div>
</template>

<script lang="ts" setup>
const { brandClasses } = useAppConfig().pages.pdp
const { product, productPrice } = usePdp()

const [DefineBadgeTemplate, BadgeTemplate] = createReusableTemplate()
const [DefineTitleTemplate, TitleTemplate] = createReusableTemplate()
</script>
